export const NOTICE_TYPE_SUCCESS = "success"
export const NOTICE_TYPE_ERROR = "error"
